import styled from "styled-components";

// Look of the Custom Email screens (same tokens as the approved mockup). Every Custom Email
// page, and the recipient drawer, renders inside <CePage>.
export const CePage = styled.div`
  --bg: #f7f8fb;
  --surface: #ffffff;
  --surface-2: #f7f8fb;
  --text: #1c2033;
  --muted: #5f6680;
  --faint: #8a90a8;
  --border: #dde0eb;
  --primary: #414d81;
  --primary-soft: #e7e9f4;
  --primary-text: #39447a;
  --good: #237a4b;
  --good-soft: #e2f3e9;
  --bad: #b7372f;
  --bad-soft: #fbe7e5;
  --warn: #94620a;
  --warn-soft: #fbf0d9;
  --mail-bg: #eef2f8;
  --mono: "IBM Plex Mono", ui-monospace, Consolas, monospace;
  --shadow: 0 1px 2px #1c20330f, 0 8px 24px #1c203314;

  color: var(--text);
  font-size: 14px;
  line-height: 1.5;
  h2, h3, h4 { margin: 0; text-wrap: balance; color: var(--text); }
  .mono { font-family: var(--mono); font-size: 12.5px; }
  .num, .n { font-variant-numeric: tabular-nums; }
  .note { font-size: 12.5px; color: var(--muted); }
  .muted { color: var(--muted); }
  .row { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }

  .crumb { color: var(--muted); font-size: 13px; margin-bottom: 4px; display: flex; flex-wrap: wrap; align-items: center; gap: 4px; }
  .backbtn { border: 0; background: none; padding: 2px 4px; margin-left: -4px; margin-right: 2px; border-radius: 4px; cursor: pointer; color: var(--primary-text); font-size: 14px; line-height: 1; }
  .backbtn:hover { background: var(--primary-soft); }
  .linkbtn { border: 0; background: none; padding: 0; font: inherit; text-align: left; cursor: pointer; color: var(--primary-text); }
  .head { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; justify-content: space-between; margin-bottom: 14px; }
  .head h2 { font-size: 20px; font-weight: 600; }

  .tag { display: inline-block; font-size: 11px; font-weight: 600; letter-spacing: 0.3px; padding: 1px 7px; border-radius: 4px; background: var(--primary-soft); color: var(--primary-text); vertical-align: 1px; white-space: nowrap; }
  .tag.new { background: var(--good-soft); color: var(--good); }
  .tag.warn { background: var(--warn-soft); color: var(--warn); }
  .tag.bad { background: var(--bad-soft); color: var(--bad); }
  .pill { display: inline-block; font-size: 11.5px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap; background: var(--surface-2); color: var(--muted); border: 1px solid var(--border); }
  .pill.ok { background: var(--good-soft); color: var(--good); border-color: transparent; }
  .pill.warn { background: var(--warn-soft); color: var(--warn); border-color: transparent; }
  .pill.bad { background: var(--bad-soft); color: var(--bad); border-color: transparent; }
  .warnbox { background: var(--warn-soft); color: var(--warn); border-radius: 6px; padding: 8px 12px; font-size: 13px; }
  .blocked { background: var(--bad-soft); color: var(--bad); border-radius: 6px; padding: 8px 12px; font-size: 13px; }

  /* tables */
  .tablewrap { overflow-x: auto; background: var(--surface); border: 1px solid var(--border); border-radius: 8px; }
  /* plain tables of the detail page / drawer (the campaign list uses the shared CustomTable) */
  .tablewrap table { border-collapse: collapse; width: 100%; font-size: 13.5px; }
  .tablewrap th { text-align: left; font-weight: 600; background: var(--surface-2); color: var(--muted); font-size: 12px; letter-spacing: 0.3px; text-transform: uppercase; padding: 10px 12px; border-bottom: 1px solid var(--border); white-space: nowrap; }
  .tablewrap td { padding: 10px 12px; border-bottom: 1px solid var(--border); vertical-align: middle; }
  .tablewrap tr:last-child td { border-bottom: 0; }
  td.n, th.n { text-align: right; }
  td.empty { text-align: center; color: var(--muted); padding: 24px; }
  .pager { display: flex; justify-content: flex-end; align-items: center; gap: 10px; padding: 8px 12px; color: var(--muted); font-size: 13px; border-top: 1px solid var(--border); }
  .bar { display: inline-block; height: 6px; border-radius: 3px; background: var(--primary); vertical-align: middle; }

  .filters { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px; }
  .sec { margin: 18px 0 8px; display: flex; justify-content: space-between; align-items: center; gap: 8px; flex-wrap: wrap; }
  .sec h3 { font-size: 15px; font-weight: 600; }
  .panel { background: var(--surface); border: 1px solid var(--border); border-radius: 8px; overflow: hidden; }

  /* detail */
  .stats { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 10px; margin-bottom: 16px; }
  @media (max-width: 900px) { .stats { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
  .stat { background: var(--surface); border: 1px solid var(--border); border-radius: 8px; padding: 10px 12px; }
  .stat b { display: block; font-size: 22px; font-weight: 600; font-variant-numeric: tabular-nums; }
  .stat span { font-size: 12px; color: var(--muted); text-transform: uppercase; letter-spacing: 0.3px; }
  .cliktop.has { cursor: pointer; }
  .cliktop.has:hover td { background: var(--surface-2); }
  .disc { display: inline-block; width: 12px; color: var(--muted); }
  .clikdetail td { background: var(--surface-2); padding: 4px 12px 10px; }
  .kv { display: grid; grid-template-columns: minmax(120px, 190px) 120px minmax(0, 1fr); font-size: 13px; }
  .kv > div { padding: 7px 10px; border-bottom: 1px solid var(--border); overflow-wrap: anywhere; }
  .kv .h { font-weight: 600; color: var(--muted); font-size: 12px; text-transform: uppercase; background: var(--surface-2); }
  .pvmeta { padding: 10px 14px; border-bottom: 1px solid var(--border); font-size: 13px; }

  /* create page */
  .chead { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap; margin-bottom: 14px; }
  .chead h2 { font-size: 22px; font-weight: 600; }
  .chead .sub { color: var(--muted); font-size: 13.5px; margin-top: 4px; max-width: 62ch; }
  .stepper { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 16px; }
  .stepper button { display: flex; align-items: center; gap: 8px; border: 1px solid var(--border); background: var(--surface); border-radius: 999px; padding: 5px 14px 5px 5px; cursor: pointer; font-size: 13px; font-weight: 500; color: var(--text); }
  .stepper button:hover { border-color: var(--primary); }
  .stepper .sn { width: 24px; height: 24px; }
  .stepper .ok .sn { background: var(--good); color: #fff; }
  .stepper .warn .sn { background: var(--warn-soft); color: var(--warn); }
  .stepper .bad .sn { background: var(--bad-soft); color: var(--bad); }
  .stepper .st { color: var(--muted); font-weight: 400; }
  .compose { display: grid; grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr); gap: 18px; align-items: start; }
  /* the two sides scroll on their own (the height is set to fit the screen in CreateCustomEmail) */
  .compose > .ce-col, .compose > .pv { height: 100%; overflow-y: auto; overscroll-behavior: contain; }
  .compose > .ce-col { padding-right: 4px; }
  @media (max-width: 1100px) {
    .compose { grid-template-columns: 1fr; }
    .compose > .ce-col, .compose > .pv { height: auto; overflow: visible; }
  }
  .scard { background: var(--surface); border: 1px solid var(--border); border-radius: 12px; box-shadow: 0 1px 2px #1c20330a; scroll-margin-top: 12px; }
  .scard + .scard { margin-top: 14px; }
  .shead { display: flex; gap: 12px; align-items: flex-start; padding: 14px 18px; border-bottom: 1px solid var(--border); }
  .shead h3 { font-size: 15.5px; font-weight: 600; }
  .shead .desc { font-size: 12.5px; color: var(--muted); margin-top: 2px; }
  .shead .pill { margin-left: auto; margin-top: 2px; }
  .sn { width: 28px; height: 28px; border-radius: 50%; background: var(--primary-soft); color: var(--primary-text); font-size: 13px; display: inline-grid; place-items: center; font-weight: 700; flex: none; }
  .sbody { padding: 16px 18px; }
  .two { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  @media (max-width: 560px) { .two { grid-template-columns: 1fr; } }
  .field { display: grid; gap: 5px; margin-bottom: 12px; }
  .field > label { font-size: 12.5px; font-weight: 600; color: var(--muted); }
  .tplcard { display: flex; gap: 12px; align-items: center; border: 1px solid var(--border); border-radius: 10px; padding: 10px 12px; background: var(--surface-2); }
  .tplcard > div { flex: 1; min-width: 0; }
  .tplcard .note { overflow-wrap: anywhere; }
  .tplicon { width: 38px; height: 38px; border-radius: 9px; background: var(--primary); color: #fff; display: grid; place-items: center; font-size: 17px; flex: none; }
  .osvars { margin-top: 10px; padding: 10px 12px; border: 1px dashed var(--border); border-radius: 8px; font-size: 12.5px; color: var(--muted); }
  .vkey { font-family: var(--mono); font-size: 12.5px; background: var(--surface-2); border: 1px solid var(--border); padding: 1px 7px; border-radius: 4px; overflow-wrap: anywhere; display: inline-block; margin: 2px 4px 2px 0; }
  .var { border: 1px solid var(--border); border-radius: 10px; padding: 12px 14px; display: grid; gap: 8px; background: var(--surface); }
  .var + .var { margin-top: 10px; }
  .var .ant-collapse { margin: 0; border: 0; background: transparent; }
  .var .ant-collapse-item { border: 0 !important; }
  .var .ant-collapse-item > .ant-collapse-header { padding: 0 !important; }
  .var .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon { padding-inline-start: 8px !important; }
  .var .ant-collapse-content { border: 0; background: transparent; }
  .var .ant-collapse-content > .ant-collapse-content-box { padding: 8px 0 0 !important; margin: 0; }
  .var.missing { border-color: var(--warn); background: var(--warn-soft); }
  .varhead { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; justify-content: space-between; }
  .ctx { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; }
  .ctx .tag { font-weight: 500; }
  .dflt { font-size: 12px; color: var(--muted); overflow-wrap: anywhere; }
  .dflt code { font-family: var(--mono); font-size: 11.5px; background: var(--surface-2); border: 1px solid var(--border); border-radius: 4px; padding: 0 5px; }
  .varctl { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 8px; align-items: center; }
  .varctl > .full { grid-column: 1 / -1; }
  @media (max-width: 560px) { .varctl { grid-template-columns: 1fr; } }
  .resolved { font-size: 12.5px; color: var(--muted); padding: 6px 10px; border: 1px dashed var(--border); border-radius: 6px; background: var(--surface); }
  /* no overflow: hidden here, the toolbar pickers (font, size, colour) open below it */
  .editor { border: 1px solid var(--border); border-radius: 6px; background: var(--surface); }
  .editor .ql-toolbar.ql-snow { border-radius: 6px 6px 0 0; }
  .editor .ql-container.ql-snow { border: 0; font-size: 14px; font-family: inherit; }
  .editor .ql-editor { min-height: 110px; padding: 10px 12px; }
  .editor .ql-editor a { color: var(--primary-text); }
  .itinmap { border: 1px dashed var(--border); border-radius: 10px; padding: 12px; margin-top: 4px; background: var(--surface-2); }
  .rtop { display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 10px; }
  .rrow2 { display: grid; grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr) auto; gap: 8px; align-items: start; margin-bottom: 12px; }
  .rrow2 .rerr, .rrow2 .rok { grid-column: 1 / -1; font-size: 12.5px; margin-top: -2px; }
  .rerr { color: var(--bad); }
  .rok { color: var(--good); }
  @media (max-width: 640px) { .rrow2 { grid-template-columns: 1fr auto; } .rrow2 > :nth-child(2) { grid-column: 1 / -1; } }
  .tofield { display: flex; gap: 10px; align-items: flex-start; }
  .tofield > label { font-size: 13px; font-weight: 600; color: var(--muted); padding-top: 6px; }
  .summary { display: grid; grid-template-columns: minmax(100px, 150px) minmax(0, 1fr); gap: 9px 14px; font-size: 13.5px; margin: 0; }
  .summary dt { color: var(--muted); }
  .summary dd { margin: 0; overflow-wrap: anywhere; }
  .blockers { display: grid; gap: 4px; margin: 14px 0 0; padding: 10px 12px; list-style: none; font-size: 13px; color: var(--bad); background: var(--bad-soft); border-radius: 8px; }
  .sendrow { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
  .confirm { border: 1px solid var(--primary); background: var(--primary-soft); border-radius: 8px; padding: 12px; margin-top: 14px; }

  /* preview */
  .pv { overflow: hidden; }
  .inbox .flash { background: #fef3c7; outline: 3px solid #f59e0b; outline-offset: 2px; border-radius: 4px; transition: all .4s; }
  .pvhead { display: flex; flex-wrap: wrap; gap: 8px; justify-content: space-between; align-items: center; padding: 12px 14px; border-bottom: 1px solid var(--border); }
  .seg { display: inline-flex; border: 1px solid var(--border); border-radius: 8px; overflow: hidden; }
  .seg button { border: 0; background: var(--surface); padding: 4px 11px; font-size: 12.5px; cursor: pointer; color: var(--muted); }
  .seg button + button { border-left: 1px solid var(--border); }
  .seg button[aria-pressed="true"] { background: var(--primary-soft); color: var(--primary-text); font-weight: 600; }
  .inbox { display: flex; gap: 10px; padding: 12px 14px; border-bottom: 1px solid var(--border); align-items: flex-start; }
  .inbox .av { width: 36px; height: 36px; border-radius: 50%; background: var(--primary); color: #fff; display: grid; place-items: center; font-weight: 700; flex: none; }
  .inbox .subj { font-weight: 600; font-size: 14px; overflow-wrap: anywhere; }
  .inbox .pre { color: var(--muted); font-size: 12.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .mailcanvas { background: var(--mail-bg); }
  .mailcanvas iframe { display: block; border: 0; width: 100%; height: 620px; background: var(--mail-bg); }
  .mailcanvas.mobile { padding: 16px 0; }
  .mailcanvas.mobile .phone { width: 375px; max-width: 100%; margin: 0 auto; border: 8px solid #1c2033; border-radius: 28px; overflow: hidden; }
  details.links { padding: 12px 14px; border-top: 1px solid var(--border); }
  details.links summary { cursor: pointer; font-size: 12px; text-transform: uppercase; letter-spacing: 0.4px; color: var(--muted); font-weight: 600; margin-bottom: 6px; }
  .lk { display: grid; grid-template-columns: auto minmax(0, 1fr); gap: 4px 10px; font-size: 12.5px; padding: 6px 0; border-top: 1px dashed var(--border); }
  .lk:first-of-type { border-top: 0; }
  .lk .u { font-family: var(--mono); font-size: 11.5px; color: var(--muted); overflow-wrap: anywhere; }

  /* chips in the user pickers (RemoteSelect tagRender) */
  .chip { display: inline-flex; gap: 6px; align-items: center; max-width: 100%; border: 1px solid var(--border); background: var(--surface-2); border-radius: 99px; padding: 1px 4px 1px 10px; margin: 2px 4px 2px 0; font-size: 12.5px; line-height: 20px; }
  .chip > span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
  .ant-select-selection-overflow-item { max-width: 100%; }
  .chip button { border: 0; background: none; cursor: pointer; color: var(--muted); padding: 0 4px; }
  .chip button:hover { color: var(--bad); }
  .ant-select-multiple .ant-select-selector { max-height: 120px; overflow-y: auto; }
  .ant-select-single .ant-select-selector,
  .ant-select-multiple .ant-select-selector,
  .ant-input, .ant-picker { border-color: var(--border); }
  .var.missing .ant-select-selector, .var.missing .ant-input { background: var(--surface); }
`;

// Tabs row of /email_campaign (Itinerary Email | Custom Email).
export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #dde0eb;
  margin-bottom: 16px;
  button { padding: 9px 14px; border: 0; background: none; cursor: pointer; color: #5f6680; border-bottom: 2px solid transparent; margin-bottom: -1px; font-size: 14px; }
  button[aria-selected="true"] { color: #39447a; border-bottom-color: #414d81; font-weight: 600; }
`;
